import React from 'react'
import styled from 'styled-components'
import { BiPowerOff } from 'react-icons/bi'
import useLogout from '../hooks/useLogout'
const Logout = ({ socket }) => {
    const logoutUser = useLogout();
    const logout = () => {
        socket.current.disconnect();
        logoutUser()
    };
    return (
        <Button onClick={logout}>
            <BiPowerOff />
        </Button>
    )
}

const Button = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    padding:0.5rem;
    border-radius:0.5rem;
    background-color:#9a86f3 ;
    border:none ;
    cursor: pointer;
    svg{
        font-size:1.3rem ;
        color:#ebe7ff ;
    }
`

export default Logout